import axios from "axios";

const instance = axios.create({
    baseURL: process.env.REACT_APP_LINK_API,
    headers: {"Content-Type": "application/json"},
});

instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("operator_session_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export default instance;
